/* Every table the Task Manager API exposes through its generated CRUD routes (api/<service>/<schema>/<table>).
   The Data screen reads each table's /meta at run time, so columns and read-only flags always match the server. */
export type EntityRow = readonly [service: string, schema: string, name: string, readOnly: boolean, adminWrite: boolean];
export const ENTITY_ROWS: readonly EntityRow[] = [
  ["identity", "sec", "AppUser", false, true],
  ["identity", "sec", "RetentionPolicy", false, true],
  ["localization", "loc", "Locale", false, false],
  ["localization", "loc", "Translation", false, false],
  ["localization", "loc", "SystemMessage", false, false],
  ["localization", "loc", "UiString", false, false],
  ["localization", "loc", "Currency", false, false],
  ["localization", "loc", "ExchangeRate", false, false],
  ["localization", "loc", "TimeZone", false, false],
  ["workspaces", "ws", "Workspace", false, true],
  ["workspaces", "ws", "WorkspaceMember", false, true],
  ["workspaces", "ws", "Team", false, false],
  ["workspaces", "ws", "TeamMember", false, false],
  ["workspaces", "ws", "Portfolio", false, false],
  ["workspaces", "ws", "ShareLink", false, true],
  ["workspaces", "prj", "Folder", false, false],
  ["workspaces", "prj", "Project", false, false],
  ["workspaces", "prj", "ProjectMember", false, true],
  ["workspaces", "prj", "Favorite", false, false],
  ["workspaces", "prj", "PortfolioProject", false, false],
  ["workspaces", "prj", "Status", false, false],
  ["workspaces", "prj", "CustomFieldDef", false, false],
  ["tasks", "tsk", "Task", false, false],
  ["tasks", "tsk", "TaskAssignee", false, false],
  ["tasks", "tsk", "TaskFollower", false, false],
  ["tasks", "tsk", "Tag", false, false],
  ["tasks", "tsk", "TaskTag", false, false],
  ["tasks", "tsk", "TaskDependency", false, false],
  ["tasks", "tsk", "Milestone", false, false],
  ["tasks", "tsk", "Checklist", false, false],
  ["tasks", "tsk", "ChecklistItem", false, false],
  ["tasks", "tsk", "CustomFieldValue", false, false],
  ["tasks", "tsk", "Comment", false, false],
  ["tasks", "tsk", "Mention", false, false],
  ["tasks", "tsk", "Reaction", false, false],
  ["tasks", "tsk", "Attachment", false, false],
  ["tasks", "tsk", "TaskActivity", true, false],
  ["tasks", "tsk", "TaskTemplate", false, false],
  ["views", "vw", "SavedView", false, false],
  ["views", "tpl", "Template", false, false],
  ["views", "tpl", "TemplateVersion", true, false],
  ["notifications", "ntf", "Notification", false, false],
  ["notifications", "ntf", "NotificationPref", false, false],
  ["notifications", "ntf", "Reminder", false, false],
  ["notifications", "ntf", "PushDevice", false, false],
  ["automation", "auto", "Rule", false, true],
  ["automation", "auto", "RuleRun", true, false],
  ["automation", "auto", "EngineCursor", true, false],
  ["automation", "auto", "RecurringTask", false, false],
  ["automation", "wf", "WorkflowDef", false, true],
  ["automation", "wf", "WorkflowInstance", true, false],
  ["automation", "wf", "ApprovalRequest", false, false],
  ["intake", "frm", "Form", false, true],
  ["intake", "frm", "FormField", false, false],
  ["intake", "frm", "FormSubmission", false, false],
  ["intake", "svc", "SlaPolicy", false, true],
  ["intake", "svc", "EscalationRule", false, true],
  ["intake", "svc", "PriorityMatrix", false, true],
  ["intake", "svc", "CatalogItem", false, false],
  ["intake", "svc", "Ticket", false, false],
  ["time", "tm", "Timesheet", true, false],
  ["time", "tm", "TimeEntry", false, false],
  ["time", "tm", "BillingRate", false, true],
  ["time", "cap", "Skill", false, false],
  ["time", "cap", "UserSkill", false, false],
  ["time", "cap", "Capacity", false, true],
  ["time", "cap", "TimeOff", false, false],
  ["time", "cap", "Allocation", false, false],
  ["time", "cap", "Scenario", false, false],
  ["time", "cap", "UtilizationTarget", false, true],
  ["goals", "gl", "Goal", false, false],
  ["goals", "gl", "KeyResult", false, false],
  ["goals", "gl", "GoalCheckIn", false, false],
  ["goals", "gl", "GoalTask", false, false],
  ["reporting", "rpt", "Dashboard", false, false],
  ["reporting", "rpt", "Widget", false, false],
  ["reporting", "rpt", "Report", false, false],
  ["reporting", "rpt", "ReportSchedule", false, false],
  ["reporting", "rpt", "ExecutivePack", false, false],
  ["reporting", "rpt", "BiExportJob", true, false],
  ["reporting", "rpt", "BiExportData", true, false],
  ["personal", "pers", "TodoList", false, false],
  ["personal", "pers", "ListShare", false, false],
  ["personal", "pers", "DayPlan", false, false],
  ["personal", "pers", "DayPlanItem", false, false],
  ["personal", "pers", "Habit", false, false],
  ["personal", "pers", "HabitCheckIn", false, false],
  ["personal", "pers", "Routine", false, false],
  ["personal", "pers", "RoutineStep", false, false],
  ["personal", "pers", "FocusSession", false, false],
  ["personal", "pers", "FocusSettings", false, false],
  ["personal", "pers", "TaskFrameworkScore", false, false],
  ["agile", "agl", "Sprint", false, false],
  ["agile", "agl", "SprintSnapshot", true, false],
  ["agile", "agl", "Release", false, false],
  ["agile", "agl", "RoadmapItem", false, false],
  ["agile", "pm", "Baseline", false, false],
  ["agile", "pm", "BaselineTask", true, false],
  ["agile", "pm", "Risk", false, false],
  ["knowledge", "kb", "Document", false, false],
  ["knowledge", "kb", "DocumentVersion", true, false],
  ["knowledge", "kb", "DecisionLog", false, false],
  ["knowledge", "ai", "Suggestion", false, false],
  ["knowledge", "ai", "AiRun", true, false],
  ["integration", "int", "Connector", false, true],
  ["integration", "int", "Webhook", false, true],
  ["integration", "int", "WebhookDelivery", true, false],
  ["integration", "int", "InboundEmailAddress", false, true],
  ["verticals", "vert", "VerticalPack", false, false],
  ["verticals", "vert", "Rfi", false, false],
  ["verticals", "vert", "PunchItem", false, false],
  ["verticals", "vert", "WorkOrder", false, false],
  ["verticals", "vert", "CampaignAsset", false, false],
  ["verticals", "vert", "OnboardingPlan", false, false],
  ["verticals", "vert", "ClientEngagement", false, false],
  ["verticals", "vert", "CustomerHealth", false, false],
  ["identity", "aud", "AuditLog", true, false],
  ["sync", "sync", "Device", false, false],
  ["sync", "sync", "Mutation", true, false],
];
export interface EntityInfo {
  service: string;
  schema: string;
  name: string;
  route: string;
  label: string;
  readOnly: boolean;
  adminWrite: boolean;
}
export const SERVICE_LABELS: Record<string, string> = {
  tasks: "Tasks", workspaces: "Workspaces & projects", identity: "People & access", localization: "Languages & currency", notifications: "Notifications",
  automation: "Automation & workflows", intake: "Service desk & forms", time: "Time & capacity", goals: "Goals", reporting: "Reports & dashboards",
  personal: "Personal", agile: "Agile & portfolio", knowledge: "Docs & assistant", integration: "Integrations", verticals: "Industry packs", views: "Views & templates", sync: "Offline sync",
};
const words = (n: string) => n.replace(/([a-z0-9])([A-Z])/g, "$1 $2").replace(/([A-Z]+)([A-Z][a-z])/g, "$1 $2");
export const ENTITIES: EntityInfo[] = ENTITY_ROWS.map(([service, schema, name, readOnly, adminWrite]) => ({
  service, schema, name, route: `${service}/${schema}/${name.toLowerCase()}`, label: words(name), readOnly, adminWrite,
}));